import React from "react";
import { useNavigate } from "react-router-dom";
import { Brand } from "../../../interfaces/types";
import { BrandMenuObject } from "./brands";
import GenericSubmenu from "./GenericSubmenu";
import { subdomainTypes } from "../../../context/availableSubdomains";
import PlusIcon from "../../../assets/plus";
import MinusIcon from "../../../assets/minusIcon";

interface Props {
  currentBrand: Brand | null;
  currentCategory: string;
  expandedGroup: string;
  branch: subdomainTypes | "";
  setCurrentBrand: React.Dispatch<React.SetStateAction<Brand | null>>;
  setCurrentCategory: React.Dispatch<React.SetStateAction<string>>;
  setExpandedGroup: React.Dispatch<React.SetStateAction<string>>;
  show: boolean;
  brandObject: BrandMenuObject;
}

const GenericBrandMenu = ({
  currentBrand,
  currentCategory,
  expandedGroup,
  branch,
  setCurrentBrand,
  setCurrentCategory,
  setExpandedGroup,
  show,
  brandObject,
}: Props) => {
  const navigate = useNavigate();

  if (show) {
    const { name, title, tags } = brandObject;
    const hasExpandedGroup = tags && tags.length > 0;

    return (
      <div className="sidebar-menu">
        <div
          className="menu-label"
          role="menubar"
          onClick={() => {
            setExpandedGroup(expandedGroup === name ? "" : name);
            if (!hasExpandedGroup) {
              setCurrentBrand(null);
              navigate(`/products/${name}?page=1`);
            }
          }}
        >
          {title}
          {hasExpandedGroup && (
            <div className="expand-icon">
              {expandedGroup === name ? (
                <MinusIcon fill="white" width={10} />
              ) : (
                <PlusIcon fill="white" width={10} />
              )}
            </div>
          )}
        </div>
        {hasExpandedGroup && expandedGroup === name && (
          <div className="sub-menu">
            <GenericSubmenu
              branch={branch}
              tags={tags}
              brandName={name}
              currentBrand={currentBrand}
              currentCategory={currentCategory}
              setCurrentBrand={setCurrentBrand}
              setCurrentCategory={setCurrentCategory}
            />
          </div>
        )}
      </div>
    );
  } else return <></>;
};

export default GenericBrandMenu;
